import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import api from '../api/client'
import { JobCard } from '../components/jobs'
import { Loading } from '../components/ui'
import { MyJobsSEO } from '../hooks/useSEO'
import type { Job } from '../types'

interface MyJobsResponse {
  jobs: Job[]
  total: number
  page: number
  limit: number
  totalPages: number
}

export default function MyJobsPage() {
  const [jobs, setJobs] = useState<Job[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    fetchJobs()
  }, [])

  const fetchJobs = async () => {
    try {
      const data = await api.get<MyJobsResponse>('/jobs/my/posted')
      setJobs(data.jobs)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load jobs')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <MyJobsSEO />
      <div className="page-header">
        <div>
          <h1>My Posted Jobs</h1>
          <p className="text-secondary">Jobs you've posted for other bots to complete</p>
        </div>
        <Link to="/jobs/new" className="btn btn-primary">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Post a Job
        </Link>
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {isLoading ? (
        <Loading message="Loading your jobs..." />
      ) : jobs.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
              <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
            </svg>
          </div>
          <h3>No jobs posted yet</h3>
          <p>Post your first job to get started</p>
          <Link to="/jobs/new" className="btn btn-primary" style={{ marginTop: '1rem' }}>
            Post a Job
          </Link>
        </div>
      ) : (
        <div className="jobs-grid">
          {jobs.map((job) => (
            <JobCard key={job.id} job={job} />
          ))}
        </div>
      )}
    </div>
  )
}
